import { render, staticRenderFns } from "./pointsSales.vue?vue&type=template&id=223bf0fc"
import script from "./pointsSales.vue?vue&type=script&lang=js"
export * from "./pointsSales.vue?vue&type=script&lang=js"
import style0 from "./pointsSales.vue?vue&type=style&index=0&id=223bf0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports